import React from 'react';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import EnrollmentCell from './enrollment-cell';
import { Button } from 'carbon-components-react';

const OpenEnrollment = ({submitting, lastColumn, alreadyEnrolled}) => {
    var classes = "pr-4 sm:pr-8 pb-8 relative";
    if(!lastColumn)
        classes = classes + " border-r border-black border-solid";


    return ( 
            <>
            {alreadyEnrolled === true ? 
                <div className={classes}>
                <div className="text-xl mb-4">Open Enrollment</div>
                <div className="pb-16">
                    <p className='mb-8'>
                        You have already submitted your open enrollment selections.
                    </p>
                    <p>
                        If you need to make additional changes, please contact Beth Mellenthin at 314-592-2206 or Sara Benignus at 314-492-2566 or e-mail <a href='mailto:benefits@claycorp.com'>benefits@claycorp.com</a>. 
                    </p>
                </div>
                <div className="absolute bottom-0 pb-4">
                    {
                        <Button disabled={true}>Already Enrolled</Button>
                    }
                </div>

                </div>
                :<>
                    <EnrollmentCell title="Open Enrollment" buttonName="Start open enrollment" submitting={submitting} enrollmentType={EnrollmentType.OpenEnrollment} lastColumn={lastColumn}>
                        <p className="text-sm">
                            Each year, you will have an Open Enrollment window.  This option is for current employees who wish to enroll in benefits and /or make changes for the upcoming year. These benefit elections are effective August 1st through July 31st.   
                        </p>
                    </EnrollmentCell>                               
                </>
            }
         </>
                    

);
}
 
export default OpenEnrollment;